import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import { parseId } from '@/helper/id'
import {
    businessesQueryKeyPrefix,
    detailsQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'

export const businessDetailsQueryKeyPrefix = [
    businessesQueryKeyPrefix,
    detailsQueryKeyPrefix,
] as const

export const businessDetailsQueryOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    id: string,
    deletedItemSelection: DeletedItemSelection
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...businessDetailsQueryKeyPrefix, id, deletedItemSelection],
        queryFn: ({ signal }) => {
            assertNotNullish(clients?.business)

            return clients.business.getBusiness(
                {
                    id: parseId(id),
                    deletedItemSelection,
                },
                { signal }
            )
        },
    })

export const useBusinessDetails = (
    id: string,
    deletedItemSelection: DeletedItemSelection
) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(
        businessDetailsQueryOptions(clients, id, deletedItemSelection)
    )
}
